import { AnyAction } from "redux";
import {
  FETCH_WISHLIST_FAILURE,
  FETCH_WISHLIST_REQUEST,
  FETCH_WISHLIST_RESET,
  FETCH_WISHLIST_SUCCESS,
  REMOVE_WISHLIST_REQUEST,
  REMOVE_WISHLIST_SUCCESS,
  REMOVE_WISHLIST_FAILURE,
} from "../actions/wishlistAction";
import { WishlistState } from "../types/wishlistTypes";

const initialState: WishlistState = {
  wishlistData: {
    products: [],
    wishlists: [],
    totalRecords: 0,
  },
  loading: false,
  error: null,
};

const wishlistReducer = (
  state = initialState,
  action: AnyAction
): WishlistState => {
  switch (action.type) {
    case FETCH_WISHLIST_REQUEST:
    case REMOVE_WISHLIST_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_WISHLIST_SUCCESS:
      return {
        ...state,
        wishlistData: action.payload,
        loading: false,
        error: null,
      };
    case REMOVE_WISHLIST_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
      };
    case FETCH_WISHLIST_FAILURE:
    case REMOVE_WISHLIST_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case FETCH_WISHLIST_RESET:
      return {
        ...state,
        wishlistData: {
          products: [],
          wishlists: [],
          totalRecords: 0,
        },
        loading: false,
        error: null,
      };
    // Handle other item-related actions here...
    default:
      return state;
  }
};

export default wishlistReducer;
